var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1704_122986)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1704_122986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.967741 1.90798e-05H1.77419C2.30863 1.90798e-05 2.74193 0.433325 2.74193 0.967761V9.88913C6.22548 3.95542 12.6806 -0.0229647 20.0639 9.97576e-05C31.0629 0.0345352 40.0172 9.033 40 20.0319C39.9827 31.063 31.035 40 20 40C14.8447 40 10.145 38.0494 6.59854 34.8461C6.18621 34.4737 6.16677 33.8331 6.55967 33.4402L7.12975 32.8702C7.4929 32.507 8.07725 32.49 8.45895 32.8336C11.5147 35.5837 15.5593 37.2581 20 37.2581C29.4955 37.2581 37.258 29.5701 37.258 20C37.258 10.5045 29.5701 2.74195 20 2.74195C13.3176 2.74195 7.5212 6.53848 4.65411 12.0968H13.871C14.4054 12.0968 14.8387 12.5301 14.8387 13.0645V13.871C14.8387 14.4054 14.4054 14.8387 13.871 14.8387H0.967741C0.433306 14.8387 0 14.4054 0 13.871V0.967761C0 0.433325 0.433306 1.90798e-05 0.967741 1.90798e-05Z",
    fill: "#61A578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.149 18.6242L22.8178 19.6535C24.1376 20.0255 25.0548 21.2281 25.0599 22.5835C25.0599 24.265 23.6739 25.6306 21.977 25.6306H21.5796V27.6689C21.5796 27.8931 21.3962 28.0765 21.172 28.0765H20.3567C20.1325 28.0765 19.949 27.8931 19.949 27.6689V25.6306H19.684C18.7159 25.6306 17.7987 25.3096 17.0547 24.7185C16.8611 24.5657 16.8407 24.2803 17.014 24.1071L17.5898 23.5211C17.7324 23.3784 17.9567 23.358 18.1197 23.4803C18.563 23.8115 19.1082 23.995 19.679 23.995H21.972C22.772 23.995 23.4242 23.358 23.4242 22.5784C23.4242 21.9516 22.9911 21.3911 22.3745 21.2179L18.7057 20.1886C17.391 19.8166 16.4688 18.6141 16.4688 17.2586C16.4688 15.5771 17.8547 14.2115 19.5516 14.2115H19.949V12.1733C19.949 11.9491 20.1325 11.7656 20.3567 11.7656H21.172C21.3962 11.7656 21.5796 11.9491 21.5796 12.1733V14.2115H21.8395C22.8076 14.2115 23.7248 14.5325 24.4688 15.1236C24.6624 15.2765 24.6828 15.5618 24.5095 15.7351L23.9337 16.3211C23.7911 16.4637 23.5669 16.4841 23.4038 16.3618C22.9605 16.0306 22.4153 15.8472 21.8446 15.8472H19.5516C18.7516 15.8472 18.0993 16.4841 18.0993 17.2637C18.0993 17.8905 18.5325 18.451 19.149 18.6242Z",
    fill: "#61A578"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1704_122986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1704_122986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunds);
export default __webpack_public_path__ + "static/media/refunds.e8da533e60f0704c6a7dbb541934edf1.svg";
export { ForwardRef as ReactComponent };